import React, { useState } from 'react';
import type { CurrencyCode, RecommendedPlanSet } from '../types';
import { PlanCard } from './PlanCard';

interface RecommendedPlanProps {
  planSet: RecommendedPlanSet;
  signupUrl: string;
}

const currencies: CurrencyCode[] = ['USD', 'GBP', 'EUR'] as const;

export const RecommendedPlan = ({ planSet, signupUrl }: RecommendedPlanProps) => {
  const [selectedCurrency, setSelectedCurrency] = useState<CurrencyCode>('USD');
  const selectedPlan = planSet[selectedCurrency];

  const onChangeCurrency = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;

    setSelectedCurrency(value as CurrencyCode);
  };

  return (
    <div className="recommended-plan-wrapper">
      <p className="text-center recommended-plan-intro">
        Based on your video output and your current average video views, other creators like you usually select the plan
        below...
      </p>

      <PlanCard plan={selectedPlan} signupUrl={signupUrl} />

      <div className="currency-toggle">
        {currencies.map((currency) => (
          <div key={currency} className="currency-radio-wrapper">
            <input
              className="visually-hidden"
              type="radio"
              value={currency}
              id={currency}
              name="currency"
              onChange={onChangeCurrency}
              checked={selectedCurrency === currency}
            />
            <label htmlFor={currency} className="currency-radio-label">
              {currency}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
